var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-group-item"},[_c('button',{class:_vm.styling,on:{"click":_vm.setMeeting}},[_vm._v("Select")]),_vm._v("\n    "+_vm._s(_vm.meeting.date)+"    "+_vm._s(_vm.meeting.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }